import React, { useState } from "react";
import Switch from "@material-ui/core/Switch";
import Radio from "@material-ui/core/Radio"; 
import RadioGroup from "@material-ui/core/RadioGroup"; 
import Visibility from "@material-ui/icons/Visibility"; 
import VisibilityOff from "@material-ui/icons/VisibilityOff"; 
import IconButton from "@material-ui/core/IconButton";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DynamicFormField from "./DynamicFormField";
import platformNTFSFieldData from "./platformNTFSFieldData";
import "./ntfs.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  S3DETAILS,
  S3Verified,
  SET_NTFS_SNACKBAR_MESSAGE,
  VERIFYS3DATA,
} from "../TenantSignUp/tenantSignUpConstants";
import verifiedButton from "../../../assets/icons/verifiedButton.svg";
import { Button, makeStyles, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { isEmpty, isNil } from "lodash";

const S3_MODE = {
  MANUAL: "MANUAL",
  AUTO_PROVISIONED: "AUTO_PROVISIONED",
};

const useStyles = makeStyles(() => ({
  customVerificationButton: {
    textTransform: "none",
    height: "32px",
    marginTop: "10px",
  },
  customVerifiedButton: {
    marginTop: "10px",
  },
  disableVerifyButton: {
    cursor: "not-allowed",
  },
  activeVerifyButton: {
    cursor: "pointer",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const NTFSPlatformChanges = ({ errorObj, setErrorObj, s3ResponseData, s3ConfigurationModeFromResponse, isEditMode}) => {
  const classes = useStyles();
  const s3Details = useSelector((state) => state.tenantSignUpReducer.s3Details);
  const isS3Verified = useSelector(
    (state) => state.tenantSignUpReducer.isS3Verified
  );
  const ntfsSnackBarMessage = useSelector(
    (state) => state.tenantSignUpReducer.ntfsSnackBarMessage
  );
  const dispatch = useDispatch();
  const { s3BucketName, accessKey, secretKey, isNTFSSelected, s3ConfigurationMode, persistedMode, isProvisioned} = s3Details;
  const [showSharedKey, setShowSharedKey] = useState(false);
  const [showAccessKey, setShowAccessKey] = useState(false);

  const toggleAccessKeyVisibility = () => {
    setShowAccessKey(!showAccessKey);
  };

  const toggleSharedKeyVisibility = () => {
    setShowSharedKey(!showSharedKey);
  };

  const handleModeChange = (event) => {
    const mode = event.target.value;

    dispatch({
      type: S3DETAILS,
      payload: {
        ...s3Details,
        s3ConfigurationMode: mode,
        s3BucketName: mode === S3_MODE.AUTO_PROVISIONED ? "" : s3BucketName,
        accessKey: mode === S3_MODE.AUTO_PROVISIONED ? "" : accessKey,
        secretKey: mode === S3_MODE.AUTO_PROVISIONED ? "" : secretKey,
      },
    });

    dispatch({ type: S3Verified, payload: false });
    setErrorObj({ ...errorObj, s3BucketName: "", accessKey: "", secretKey: "" });
  };

  // Once a configuration exists its mode is fixed. Switching between manual
  // and automatic would mean pointing the tenant at a different bucket.
  const isModeLocked = !isNil(persistedMode);

  // NTFS configuration is only available while editing an existing tenant.
  if (!isEditMode) {
    return null;
  }

  const fieldConfig = {
    "S3 Bucket": {
      value: s3BucketName,
      onChange: (event) => {
        dispatch({
          type: S3DETAILS,
          payload: { ...s3Details, s3BucketName: event.target.value },
        });
        dispatch({ type: S3Verified, payload: false });
        setErrorObj({
          ...errorObj,
          s3BucketName: "",
        });
      },
      errorMessage: errorObj.s3BucketName,
      important: true,
    },
    "Access Key": {
      value: accessKey,
      onChange: (event) => {
        dispatch({
          type: S3DETAILS,
          payload: { ...s3Details, accessKey: event.target.value },
        });
        dispatch({ type: S3Verified, payload: false });
        setErrorObj({
          ...errorObj,
          accessKey: "",
        });
      },
      showPassword: showAccessKey,
      togglePasswordVisibility: toggleAccessKeyVisibility,
      errorMessage: errorObj.accessKey,
      important: true,
    },
    "Secret Key": {
      value: secretKey,
      onChange: (event) => {
        dispatch({
          type: S3DETAILS,
          payload: { ...s3Details, secretKey: event.target.value },
        });
        dispatch({ type: S3Verified, payload: false });
        setErrorObj({
          ...errorObj,
          secretKey: "",
        });
      },
      showPassword: showSharedKey,
      togglePasswordVisibility: toggleSharedKeyVisibility,
      errorMessage: errorObj.secretKey,
      important: true,
    },
  };

  const renderFields = () => {
    return platformNTFSFieldData.map((field, index) => {
      const { label, type, placeholder, autoComplete } = field;
      const config = fieldConfig[label];

      return (
        <DynamicFormField
          key={index}
          label={label}
          value={config.value}
          type={type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          onChange={config.onChange}
          showPassword={config.showPassword}
          togglePasswordVisibility={config.togglePasswordVisibility}
          error={config.errorMessage}
          important={config.important}
        />
      );
    });
  };

  const handleS3Verification = () => {
    dispatch({ type: VERIFYS3DATA });
  };
  const handleS3ButtonDisable = () => {
    return isEmpty(s3BucketName) || isEmpty(accessKey) || isEmpty(secretKey);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch({type: SET_NTFS_SNACKBAR_MESSAGE, payload: ""});
  };

  // Function to render verification button
  const renderVerification = () => {
    if (isS3Verified) {
      return (
        <div className="logSourceVerificationContainer">
          <img
            src={verifiedButton}
            alt="verified"
            className={classes.customVerifiedButton}
          />
        </div>
      );
    }

    const isButtonDisabled = handleS3ButtonDisable();
    const buttonTitle = isButtonDisabled
      ? "Please enter all the details of S3"
      : "";

    return (
      <div title={buttonTitle}>
        <Button
        variant="contained"
        color="primary"
        onClick={handleS3Verification}
        disabled={isButtonDisabled}
        className={classes.customVerificationButton}
      >
        Verification
      </Button>
      </div>
    );
  };

    const renderProvisionedFields = () => {
    return (
      <div className="ntfsS3fieldContainer">
        <div className="provisionedField">
          <span className="provisionedFieldLabel">S3 Bucket</span>
          <span className="provisionedFieldValue">{s3BucketName}</span>
        </div>

        <div className="provisionedField">
          <span className="provisionedFieldLabel">Access Key</span>
          <span className="provisionedFieldValue">
            {showAccessKey ? accessKey : "••••••••••••••••••••••••"}
          </span>
          <IconButton size="small" onClick={toggleAccessKeyVisibility}>
            {showAccessKey ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </div>

        <div className="provisionedField">
          <span className="provisionedFieldLabel">Secret Key</span>
          <span className="provisionedFieldValue">
            {showSharedKey ? secretKey : "••••••••••••••••••••••••"}
          </span>
          <IconButton size="small" onClick={toggleSharedKeyVisibility}>
            {showSharedKey ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </div>
      </div>
    );
  };

  const renderManualSection = () => {
    return (
      <div>
        <div className="ntfsS3fieldContainer">{renderFields()}</div>
        <div
          className={
            handleS3ButtonDisable()
              ? classes.disableVerifyButton
              : classes.activeVerifyButton
          }
        >
          {renderVerification()}
        </div>
      </div>
    );
  };

  const renderAutomaticSection = () => {
    if (isProvisioned) {
      return renderProvisionedFields();
    }

    return (
      <div className="provisionNote">
        A private S3 bucket and dedicated credentials will be created
        automatically when you save.
      </div>
    );
  };

  return (
    <div className="ntfsMainContainer">
      <div className="selectiveUsers platformNTFS">
        <span className="selectiveUserText platformNTFS">NTFS</span>
        <FormControlLabel
          control={
            <Switch
              checked={isNTFSSelected}
              onChange={() =>
                dispatch({
                  type: S3DETAILS,
                  payload: { ...s3Details, isNTFSSelected: !isNTFSSelected },
                })
              }
              color="primary"
            />
          }
        />
      </div>
      {isNTFSSelected && (
        <div>
          <RadioGroup
            className="modeRadioGroup"
            value={s3ConfigurationMode || S3_MODE.MANUAL}
            onChange={handleModeChange}
          >
            <FormControlLabel
              value={S3_MODE.MANUAL}
              control={<Radio color="primary" />}
              label="Provide S3 details"
              disabled={isModeLocked && persistedMode !== S3_MODE.MANUAL}
            />
            <FormControlLabel
              value={S3_MODE.AUTO_PROVISIONED}
              control={<Radio color="primary" />}
              label="Provision automatically"
              disabled={isModeLocked && persistedMode !== S3_MODE.AUTO_PROVISIONED}
            />
          </RadioGroup>
          {s3ConfigurationMode === S3_MODE.AUTO_PROVISIONED
            ? renderAutomaticSection()
            : renderManualSection()}
        </div>
      )}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={!isEmpty(ntfsSnackBarMessage)}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {ntfsSnackBarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NTFSPlatformChanges;
